<div class="lightbox" *ngIf="showZoom" [ngClass]="{ 'active': showZoom }">
  <button mat-flat-button (click)="setZoom(false)" class="mb-2">
    <mat-icon>close</mat-icon>
    Cerrar
  </button>
  <img [src]="src" class="imgZoom">
</div>
